import Reveal, { Eyebrow } from "./Reveal";
import { Minus } from "lucide-react";

const LIMITS = [
  { title: "No live call transfer", body: "Escalations are flagged for human follow-up, not handed over live." },
  { title: "No auto-dialling skip-traced numbers", body: "First call to a skip-traced number is identity check only." },
  { title: "No mid-flight version changes", body: "A running campaign never changes. New versions apply to new campaigns only." },
  { title: "No cross-tenant views", body: "Nobody sees another tenant's customers — by design." },
  { title: "No human dialler in the app", body: "The AI places campaign calls. People work their queue." },
];

const HonestList = () => (
  <section data-testid="honest-list-section" className="py-20 sm:py-28 bg-[#09090B] text-[#FAF9F6]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>Said plainly, up front</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
              What Voicxent cannot do.
            </h2>
            <p className="text-zinc-400 mt-6 leading-relaxed max-w-md">
              We would rather you know the edges before you buy than discover them after. These are
              deliberate boundaries, not missing features on a roadmap.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          {LIMITS.map((l, i) => (
            <Reveal key={l.title} delay={i * 0.06}>
              <div
                data-testid={`limit-item-${i + 1}`}
                className="flex gap-5 py-6 border-b border-white/10 first:border-t items-start group"
              >
                <span className="mt-1.5 w-7 h-7 rounded-full border border-white/20 flex items-center justify-center shrink-0 group-hover:border-[#2563EB] group-hover:bg-[#2563EB] transition-colors duration-300">
                  <Minus size={14} className="text-zinc-300 group-hover:text-white transition-colors duration-300" />
                </span>
                <div>
                  <h3 className="font-display font-bold text-lg sm:text-xl">{l.title}</h3>
                  <p className="text-zinc-400 text-sm sm:text-base mt-1.5 leading-relaxed">{l.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HonestList;
